import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import EnvironmentPage from "../views/EnvironmentPage.vue";
import RegTypePage from "../views/RegTypePage.vue";
import AccountPage from "../views/AccountPage.vue";
import UnitPage from "../views/UnitPage.vue";
import ResourcePage from "../views/ResourcePage.vue";
import ItemPage from "../views/ItemPage.vue";
import KanbanPage from "../views/KanbanPage.vue";
import StageTypePage from "../views/StageTypePage.vue";
import VersionPage from "../views/VersionPage.vue";
import JobPage from "../views/JobPage.vue";
import SolicJobPage from "../views/SolicJobPage.vue";
import JobStagePage from "../views/JobStagePage.vue";
import LoginPage from "../views/LoginPage.vue";
import NotFoundPage from "../views/NotFoundPage.vue";
import UserPage from "../views/UserPage.vue";
import RegistryResourcePage from "../views/RegistryResourcePage.vue";
import RegistryRegTypePage from "../views/RegistryRegTypePage.vue";
import JobKanbanPage from "../views/JobKanbanPage.vue";
import JobGroupKanbanPage from "../views/JobGroupKanbanPage.vue";
import ResourceKanbanPage from "../views/ResourceKanbanPage.vue";
import NotAuthorized from "../views/NotAuthorized.vue";
import EmptyPage from "../views/EmptyPage.vue";
import AnalyzeInputGroupPage from "../views/AnalyzeInputGroupPage.vue";
import AnalyzeInputPage from "../views/AnalyzeInputPage.vue";
import AnalyzePage from "../views/AnalyzePage.vue";
import ReportPage from "../views/ReportPage.vue";
import PrinterPage from "../views/PrinterPage.vue";
import ActionPage from "../views/ActionPage.vue";
import EntityFieldCustomPage from "../views/EntityFieldCustomPage.vue";
import RegSearchPage from "../views/RegSearchPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/Login",
    name: "Login",
    title: "Login",
    component: LoginPage,
  },
  {
    path: "*",
    name: "NotFound",
    title: "Not Found",
    component: NotFoundPage,
  },
  {
    path: "/EntityFieldCustoms",
    name: "EntityFieldCustoms",
    title: "EntityFieldCustom",
    component: EntityFieldCustomPage,
  },
  {
    path: "/AnalyzePage",
    name: "Analyze",
    title: "Analyze",
    component: AnalyzePage,
  },
  {
    path: "/AnalyzeInputPage",
    name: "AnalyzeInput",
    title: "AnalyzeInput",
    component: AnalyzeInputPage,
  },
  {
    path: "/AnalyzeInputGroupPage",
    name: "AnalyzeInputGroup",
    title: "AnalyzeGroupPage",
    component: AnalyzeInputGroupPage,
  },
  {
    path: "/Reports",
    name: "Reports",
    title: "Reports",
    component: ReportPage,
  },
  {
    path: "/Actions",
    name: "Actions",
    title: "Actions",
    component: ActionPage,
  },
  {
    path: "/Printers",
    name: "Printers",
    title: "Printers",
    component: PrinterPage,
  },
  {
    path: "/NotAuthorized",
    name: "NotAuthorized",
    title: "Not Authorized",
    component: NotAuthorized,
  },
  {
    path: "/",
    name: "Empty",
    component: EmptyPage,
  },
  // {
  //   path: "/RegEdit",
  //   name: "RegEdit",
  //   component: RegEdit
  // },
  {
    path: "/Home",
    name: "Home",
    title: "Home",
    component: Home,
  },
  {
    path: "/kanban",
    name: "Kanban",
    title: "Kanban",
    component: KanbanPage,
    children: [
      {
        path: "/kanban-job",
        name: "KanbanJob",
        title: "KanbanJob",
        component: JobKanbanPage,
      },
      {
        path: "/kanban-job-group",
        name: "KanbanJobGroup",
        title: "KanbanJobGroup",
        component: JobGroupKanbanPage,
      },
      {
        path: "/kanban-resource",
        name: "KanbanResource",
        title: "Kanban Resource",
        component: ResourceKanbanPage,
      },
    ],
  },
  {
    path: "/job-kanban",
    name: "JobKanban",
    title: "Job Kanban",
    component: JobKanbanPage,
  },
  {
    path: "/resource-kanban",
    name: "ResourceKanban",
    title: "ResourceKanban",
    component: ResourceKanbanPage,
  },
  {
    path: "/Registry/Resource",
    name: "Registry Resource",
    title: "Registry Resource",
    component: RegistryResourcePage,
  },
  {
    path: "/Registry/RegType",
    name: "Registry RegType",
    title: "Registry RegType",
    component: RegistryRegTypePage,
  },
  {
    path: "/Users",
    name: "Users",
    title: "Users",
    component: UserPage,
  },

  {
    path: "/RegSearch",
    name: "RegSearch",
    title: "RegSearch",
    component: RegSearchPage,
  },
  {
    path: "/Environments",
    name: "Environments",
    title: "Environments",
    component: EnvironmentPage,
  },
  {
    path: "/RegTypes",
    name: "Reg Types",
    title: "Reg Types",
    component: RegTypePage,
  },
  {
    path: "/Accounts",
    name: "Accounts",
    title: "Accounts",
    component: AccountPage,
  },
  {
    path: "/Units",
    name: "Units",
    title: "Units",
    component: UnitPage,
  },
  {
    path: "/Jobs",
    name: "Jobs",
    title: "Jobs",
    component: JobPage,
  },
  {
    path: "/Solic/Jobs",
    name: "SolicJobs",
    title: "SolicJobs",
    component: SolicJobPage,
  },
  {
    path: "/JobStages/:jobId",
    name: "Job Stages",
    title: "Job Stages",
    component: JobStagePage,
  },
  {
    path: "/Resources",
    name: "Resources",
    title: "Resources",
    component: ResourcePage,
  },
  {
    path: "/Items",
    name: "Items",
    title: "Items",
    component: ItemPage,
  },
  {
    path: "/Version/:itemId",
    name: "Version",
    title: "Version",
    component: VersionPage,
  },
  {
    path: "/StageTypes",
    name: "Stage Types",
    title: "Stage Types",
    component: StageTypePage,
  },
  {
    path: "/about",
    name: "About",
    title: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  //  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  let userParams = await Vue.prototype.$auth.getUserParams();
  if (
    to.name != "Login" &&
    to.name != "NotFound" &&
    to.name != "NotAuthorized" &&
    (userParams == null || userParams.accessToken == null)
  ) {
    await router.push({ name: "Login" });
  }
  await next();
});

export default router;
